import React from 'react';
import PropTypes from 'prop-types';

import { MdEdit } from 'react-icons/lib/md';

const SCOPE_TABS = [
  {name: 'scope',    label: 'Scope'},
  {name: 'webScope', label: 'Web Scope'},
]

const Tabs = ({ tabs, current, setTab, editWs, canEditWs }) => (
  <div className="tabs clearfix">
    {tabs.map((tab, i) =>
      <div key={i}
        className={'tab' + (current === tab.name ? ' active' : '')}
        onClick={() => setTab(tab.name)}>
        {tab.label}

        {current === 'webScope' && tab.name === 'webScope' && canEditWs === true
          ? <span className="float-right" onClick={() => editWs(tab.name)}><MdEdit size={16} color='#8492a6' /></span>
          : null
        }
      </div>
    )}
  </div>
);

Tabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  current: PropTypes.string.isRequired,
  setTab: PropTypes.func.isRequired,
  editWs: PropTypes.func.isRequired,
  canEditWs: PropTypes.bool.isRequired
}

const FieldLike = ({ label, value }) => (
  <div className="controls">
    <span className="label">{label}</span>
    <span className="value">{value}</span>
  </div>
);

FieldLike.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
}

export function getOptionsForProgramType(programTypes, divisionName) {
  if (programTypes && divisionName) {
    if (divisionName === 'Public Buildings') {
      let filteredPB = programTypes.filter(pt => pt.divisionId === 1);
      return filteredPB.map(value => {
        return { label: value.programType, value: value.id }
      });
    }
    else if (divisionName === 'Infrastructure') {
      let filteredPB = programTypes.filter(pt => pt.divisionId === 0);
      return filteredPB.map(value => {
        return { label: value.programType, value: value.id }
      });
    }
  }
  else return null;
}

export function getOptionsForProjectType (projectTypes, divisionName) {
  
  let divisionId = -1;
  if (divisionName === 'Public Buildings')
    divisionId = 1;
  else if (divisionName === 'Infrastructure')
    divisionId = 0;

  let pts = [];
  if (divisionId !== -1)
    pts = projectTypes.filter(pt => pt.divisionId === divisionId);
  else
    pts = projectTypes;

  if(pts) {
    return pts.map(pt => {
      const value = pt.projectType;
      return { label: value, value: pt.id }
    });
  }
}

export {
  Tabs,
  SCOPE_TABS,
  FieldLike,
}
